/** Recipe caps — aligned with app/constants/planFeatures.js and express defaultLimits. */
export const MENU_BUILDER_RECIPE_LIMITS = {
  Free: 50,
  Starter: 200,
  Growth: null,
  Pro: null,
}

export const getMenuBuilderPlanMax = currentPlan => {
  const raw = String(currentPlan || 'Free').trim()
  const plan = raw
    ? raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase()
    : 'Free'
  if (Object.prototype.hasOwnProperty.call(MENU_BUILDER_RECIPE_LIMITS, plan)) {
    return MENU_BUILDER_RECIPE_LIMITS[plan]
  }
  return MENU_BUILDER_RECIPE_LIMITS.Free
}
